import { render } from "./goal-tracking.vue?vue&type=template&id=792a54b0"
import script from "./goal-tracking.vue?vue&type=script&lang=js"
export * from "./goal-tracking.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__